import { render, staticRenderFns } from "./EmailTranscriptModal.vue?vue&type=template&id=56af2b2f&"
import script from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"
export * from "./EmailTranscriptModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTranscriptModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports